import React from 'react';

const DropDownIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="M0 0L24 0 24 24 0 24z"
                    transform="translate(-280 -930) translate(24 731) translate(16 164) translate(240 35)"
                  />
                  <path
                    fill="#21272E"
                    d="M8.33 11.862l2.886 2.82c.434.424 1.136.424 1.57 0l2.886-2.82c.702-.686.201-1.862-.79-1.862H9.11c-.991 0-1.482 1.176-.78 1.862z"
                    transform="translate(-280 -930) translate(24 731) translate(16 164) translate(240 35)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DropDownIcon;
